export default __webpack_public_path__ + "static/media/BodyShop.aa429f64.jpg";